module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00328.3a0a5629.jpg";